import { Injectable } from "@angular/core";
import { LocalStorageCachingStorageService, SsoAccountFacade } from "common";
import { CustomerFacade } from "common";
import { AuthService } from "../../features/auth/infrastructure/auth.service";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(
    private oauthService: AuthService,
    private customerFacade: CustomerFacade,
    private ssoAccountFacade: SsoAccountFacade,
    private cache: LocalStorageCachingStorageService
  ) {}

  logout() {
    return this.oauthService.logout().pipe(tap(() => this.removeSession())).subscribe();
  }

  private removeSession(): void {
    this.oauthService.sessionEndLocal();
    this.ssoAccountFacade.clearSsoAccountCache();
    this.customerFacade.clearCustomerCache();
    this.cache.clear();
  }
}
